module.exports = __webpack_public_path__ + "job-role-744b966d/og-xing-logo-47744aa374db46e83e91131f3a8a0db5.png";